"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectFormFieldByConfig = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _reactHookForm = require("react-hook-form");
var _components = require("../components");
var _utils = require("../utils");
var _SharedStyledComponents = require("./SharedStyledComponents");
var _jsxRuntime = require("react/jsx-runtime");
const SelectWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  alignItems: 'center',
  marginTop: theme.spacing(0)
}));
const SelectFormFieldByConfig = props => {
  const {
    name,
    label,
    title,
    isEditable,
    isAvailable,
    isMandatory,
    displayOrder,
    options,
    initialValue,
    isAddressMatchRequired,
    variant,
    placeholder,
    labelMapper,
    customErrors,
    isDisabled,
    autoFocus,
    customMaxWidth,
    ...selectField
  } = props;
  const {
    getTestIdProps,
    getTestId
  } = (0, _testidGenerator.default)();
  const submitError = customErrors?.find(error => error.fieldName?.toLowerCase() === name.toLowerCase());
  const errorMessage = submitError ? (0, _utils.getErrorLocalizationByCode)(submitError?.errorCode, name) : undefined;
  const renderSelectOption = (item, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.MenuItem, {
    value: item.value,
    ...getTestIdProps('select-field-option'),
    children: item.label
  }, index);
  const availableOptions = selectField.availableOptions?.map(opt => ({
    label: labelMapper ? labelMapper.getLocalizationKey(opt) : opt,
    value: opt
  }));
  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions -- TODO we must fixed and checked correct working in separate story
  const currentOptions = availableOptions?.length ? availableOptions : options;
  const partOfAddress = name.includes('address') ? 10 : 1;

  // we need start tabindex from 1 but displayOrder starts from 0
  const correctTabIndex = typeof displayOrder === 'number' ? displayOrder + partOfAddress : displayOrder;
  const renderField = () => /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Grid, {
    size: {
      xs: 12,
      sm: 12
    },
    style: {
      order: displayOrder,
      textAlign: 'left'
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Box, {
      margin: "0 auto 20px",
      maxWidth: customMaxWidth ?? 500,
      children: [
      // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions -- TODO we must fixed and checked correct working in separate story
      title ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
        variant: "body1",
        color: "textPrimary",
        sx: {
          fontWeight: 'bold',
          marginBottom: '10px',
          textAlign: 'left'
        },
        ...getTestIdProps(`${name}-select-field-title`),
        children: title
      }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactHookForm.Controller, {
        name: name,
        defaultValue: initialValue,
        render: ({
          field,
          fieldState
        }) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_SharedStyledComponents.StyledFormControl, {
          fullWidth: true,
          error: !!fieldState.error,
          required: isMandatory,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.InputLabel, {
            id: `${name}-label`,
            children: label
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(SelectWrapper, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Select, {
              ...field,
              fullWidth: true,
              variant: variant ?? 'outlined',
              label: label,
              labelId: `${name}-label`,
              error: !!fieldState.error,
              required: isMandatory,
              disabled: isDisabled ?? !isEditable,
              inputProps: {
                tabIndex: correctTabIndex,
                readOnly: isAddressMatchRequired ?? false,
                autoFocus,
                'data-testid': getTestId(`${name}-select-field`)
              },
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.MenuItem, {
                disabled: true,
                value: undefined,
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.FormHelperText, {
                  children: placeholder
                })
              }), currentOptions?.map(renderSelectOption)]
            })
          }), fieldState.error ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.FormHelperText, {
            error: true,
            children: fieldState.error.message
          }) : null, errorMessage ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.ErrorMessage, {
            errorMessage: errorMessage
          }) : null]
        })
      })]
    })
  });
  const fieldComponent = isAvailable && renderField();
  return fieldComponent;
};
exports.SelectFormFieldByConfig = SelectFormFieldByConfig;
//# sourceMappingURL=SelectFormFieldByConfig.js.map